<template>
  <div id="error">




    <div style="padding-top: 209px">
      <img
        style="width: 470px; height: 323px; display: block; margin: 0 auto"
        src="/static/img/404.png"
      />
    </div>
    <div>
      <p
        style="
          height: 70px;
          font-size: 50px;
          font-family: PingFang-SC-Heavy, PingFang-SC;
          font-weight: 800;
          color: #7a7a7a;
          line-height: 70px;
          margin-top: 23px;
        "
      >
        Sorry
      </p>
      <p
        style="
          height: 24px;
          font-size: 18px;
          font-family: MicrosoftYaHei;
          color: #262626;
          line-height: 24px;
          margin-top: 10px;
          margin-bottom: 20px;
        "
      >
        很抱歉，页面不小心走丢了
      </p>
      <span class="sx" href="#" @click="sx()">刷新</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      search_keywords: "",
    };
  },
  methods: {
    goback: function () {
      history.go(-1);
    },
    gohome: function () {
      this.$router.push({ name: "Home" });
    },
    sx() {
      location.reload();
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
#error {
  min-width: 1200px;

  background: url(/static/img/404bg.jpg) no-repeat;
  background-size: 100%;
  height: 100vh;
  position: relative;

  .txt {
    text-align: left;
    color: #402551;
    position: absolute;
    top: 21%;
    left: 10%;
    h5 {
      font-size: 60px;
      font-weight: 600;
    }
    p {
      font-size: 28px;
    }
  }
  .goback {
    cursor: pointer;
    width: 203px;
    height: 61px;
    line-height: 61px;
    font-size: 24px;
    border-radius: 10px;
    position: absolute;
    top: 86%;
    right: 350px;
  }
  .gohome {
    cursor: pointer;
    width: 203px;
    height: 61px;
    line-height: 61px;
    font-size: 24px;
    border-radius: 10px;
    position: absolute;
    top: 86%;
    right: 100px;
  }
  .sx {
    display: inline-block;
    width: 168px;
    height: 40px;
    background: #e23130;
    border-radius: 6px;
    border: 1px solid #e23130;
    color: #fff;
    line-height: 40px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/error.vue